// Short-lived stash for the `setup_token` returned by /invitations/:token/accept
// so refreshing the page or closing the tab mid-TOTP-enrollment can pick up
// where the user left off. Scoped per-invitation-token to avoid collisions if
// the same browser were to walk through multiple invites. The setup_token is
// a 5-minute mfa_session JWT — server-side short-lived — so stashing it in
// sessionStorage is acceptable per the same reasoning as the login mfa_session.
// It is never written to localStorage.

const PREFIX = "finance.invitation.setup:";

function key(token: string): string {
  return `${PREFIX}${token}`;
}

export function rememberInvitationSetup(invitationToken: string, setupToken: string): void {
  try {
    sessionStorage.setItem(key(invitationToken), setupToken);
  } catch {
    // sessionStorage can be unavailable; the in-memory flow still works on the
    // happy path. Resume-after-refresh is best effort.
  }
}

export function readInvitationSetup(invitationToken: string): string | null {
  try {
    return sessionStorage.getItem(key(invitationToken));
  } catch {
    return null;
  }
}

export function clearInvitationSetup(invitationToken: string): void {
  try {
    sessionStorage.removeItem(key(invitationToken));
  } catch {
    // best effort
  }
}
